<template>
  <q-card flat>
    <q-card-section class="no-padding" v-if="(velocityItems || value) &&
    !$store.state.roles.some(v=>['user_visitor'].includes(v)) &&
    !$q.screen.lt.md">
      <div class="flex flex-center">
        <CurrentVelocity :items="velocityItems"/>
        <CurrentSaleRate :items="velocityItems" class="q-ml-xs"/>
        <ConversionRate :items="velocityItems" class="q-ml-xs"/>
        <CustomerUniq :class="$q.screen.lt.md?'q-mt-xs':''" :items="velocityItems" class="q-ml-xs"/>
        <CustomerRetention :class="$q.screen.lt.md?'q-mt-xs':''" :items="velocityItems" class="q-ml-xs"/>
        <NewCustomer :class="$q.screen.lt.md?'q-mt-xs':''" :items="newCustomerList" class="q-ml-xs"/>
        <NewCustomerNotActive :class="$q.screen.lt.md?'q-mt-xs':''" :items="newCustomerList" class="q-ml-xs"/>
        <NewCustomerActive :class="$q.screen.lt.md?'q-mt-xs':''" :items="newCustomerList" class="q-ml-xs"/>
        <AverageSaleRateInMonth :class="$q.screen.lt.md?'q-mt-xs':''" :items="undefined"
                                :value="Math.round(totalSale/numberOfMonthDays())" class="q-ml-xs"/>
      </div>
    </q-card-section>
    <q-card-section class="no-padding" v-if="$q.screen.lt.md">
      <q-carousel
          v-model="slideSummary"
          height="106px"
          transition-prev="slide-right"
          transition-next="slide-left"
          swipeable
          animated
          control-color="primary"
          arrows
      >
        <q-carousel-slide name="CurrentVelocity" class="column no-wrap">
          <CurrentVelocity :items="velocityItems"/>
        </q-carousel-slide>
        <q-carousel-slide name="CurrentSaleRate" class="column no-wrap">
          <CurrentSaleRate :items="velocityItems" class="q-ml-xs"/>
        </q-carousel-slide>
        <q-carousel-slide name="ConversionRate" class="column no-wrap">
          <ConversionRate :items="velocityItems" class="q-ml-xs"/>
        </q-carousel-slide>
        <q-carousel-slide name="CustomerUniq" class="column no-wrap">
          <CustomerUniq :class="$q.screen.lt.md?'q-mt-xs':''" :items="velocityItems" class="q-ml-xs"/>
        </q-carousel-slide>
        <q-carousel-slide name="CustomerRetention" class="column no-wrap">
          <CustomerRetention :class="$q.screen.lt.md?'q-mt-xs':''" :items="velocityItems" class="q-ml-xs"/>
        </q-carousel-slide>
        <q-carousel-slide name="NewCustomer" class="column no-wrap">
          <NewCustomer :class="$q.screen.lt.md?'q-mt-xs':''" :items="newCustomerList" class="q-ml-xs"/>
        </q-carousel-slide>
        <q-carousel-slide name="NewCustomerNotActive" class="column no-wrap">
          <NewCustomerNotActive :class="$q.screen.lt.md?'q-mt-xs':''" :items="newCustomerList" class="q-ml-xs"/>
        </q-carousel-slide>
        <q-carousel-slide name="NewCustomerActive" class="column no-wrap">
          <NewCustomerActive :class="$q.screen.lt.md?'q-mt-xs':''" :items="newCustomerList" class="q-ml-xs"/>
        </q-carousel-slide>
        <q-carousel-slide name="AverageSaleRateInMonth" class="column no-wrap">
          <AverageSaleRateInMonth :class="$q.screen.lt.md?'q-mt-xs':''" :items="undefined"
                                  :value="Math.round(totalSale/numberOfMonthDays())" class="q-ml-xs"/>
        </q-carousel-slide>
      </q-carousel>
    </q-card-section>
    <q-card-section class="no-padding">
      <div class="flex flex-center">
        <div v-if="!$q.screen.lt.md" class="row flex flex-center">
          <div v-for="(item, index) in lodash.take(lodash.orderBy(items,['Sale_Pay','ExiCount'],['desc','desc']),15)"
               :key="index">
            <q-card :class="item.selected?'q-ma-sm shadow-5':'q-ma-xs'" bordered>
              <q-card-section class="no-padding text-center">
                <q-btn @click="$emit('city-selected', []);item.selected = false;"
                       flat
                       round
                       v-if="item.selected" icon="cancel"
                       padding="none" size="xs" color="deep-orange">
                  <q-tooltip>
                    لغو شرط
                  </q-tooltip>
                </q-btn>
              </q-card-section>
              <q-card-section class="no-padding text-center q-gutter-none">
                <q-avatar v-if="item.Digikala" size="xs" class="q-mt-xs">
                  <img src="../../assets/Sign.svg" alt="sign">
                </q-avatar>
                <q-chip :color="`blue-grey-7`" text-color="white" square class="q-mt-xs"
                        clickable
                        @click="$emit('city-selected', [item]);item.selected = true;cancelAllFilter(item)"
                        :label="item.City" icon="location_city">
                  <q-badge :color="`red-10`" text-color="white" floating :label="item.ExiCount"/>
                </q-chip>
                <q-space/>
                <q-chip dense :color="`indigo-10`" text-color="white" square
                        label="تاخیر"
                        icon="event">
                  <q-badge color="red-10" class="q-ml-xs" rounded text-color="white" :label="item.SendDelay"/>
                  <span class="q-ml-xs">روز</span>
                  <q-tooltip content-style="background-color:transparent">
                    <q-card>
                      <q-card-section class="no-padding">
                        <q-chip dense :color="`deep-orange-10`" text-color="white" square
                                label="تاریخ اولین سفارش"
                                icon="event">
                          <q-badge color="indigo-10" class="q-ml-xs" rounded text-color="white" :label="item.MinDate"/>
                        </q-chip>
                        <q-space v-if="item.MinDate!==item.MaxDate"/>
                        <q-chip dense :color="`deep-orange-10`" text-color="white" square
                                v-if="item.MinDate!==item.MaxDate"
                                label="تاریخ آخرین سفارش"
                                icon="event">
                          <q-badge color="indigo-10" class="q-ml-xs" rounded text-color="white" :label="item.MaxDate"/>
                        </q-chip>
                      </q-card-section>
                    </q-card>
                  </q-tooltip>
                </q-chip>
                <q-space/>
                <q-chip dense :color="`green-10`" text-color="white" square
                        label="جمع مبلغ"
                        icon="attach_money">
                  <q-badge color="indigo-10" class="q-ml-xs" rounded text-color="white"
                           :label="item.Sale_Pay.toLocaleString()"/>

                  <q-tooltip content-class="bg-white text-center">
                    <q-chip
                        v-if="$store.state.roles.some(v=>['admin','can_see_by_price','can_see_buy_price_summary_order_trace'].includes(v))"
                        dense
                        color="indigo" text-color="white" square
                        label="اختلاف با خرید روز"
                        icon="attach_money">
                      <q-badge class="q-ml-xs" style="direction: ltr"
                               :color="(item.Sale_Pay-item.Buy_DayPrice)>0?'green':'red-10'"
                               :label="(item.Sale_Pay-item.Buy_DayPrice).toLocaleString()"/>
                    </q-chip>
                    <q-space/>
                    <q-chip dense square :label="`${item.Box} کارتن`"/>
                    <q-space/>
                    <q-chip dense square :label="`${item.Weight} کیلو`"/>
                  </q-tooltip>
                </q-chip>
              </q-card-section>
            </q-card>
          </div>
        </div>
        <q-carousel v-if="$q.screen.lt.md && items.length>0"
                    v-model="slide"
                    height="197px"
                    transition-prev="slide-right"
                    transition-next="slide-left"
                    swipeable
                    animated
                    control-color="primary"
                    padding
                    arrows
                    class="shadow-2 rounded-borders full-width q-mt-sm"
        >
          <q-carousel-slide :name="index" class="column no-wrap" :key="index"
                            v-for="(item, index) in lodash.orderBy(items,['Sale_Pay','ExiCount'],['desc','desc'])">
            <q-card flat>
              <q-card-section class="no-padding" align="center">
                <q-btn @click="$emit('city-selected', []);item.selected = false;"
                       flat
                       round
                       v-if="item.selected" icon="cancel"
                       padding="none" size="xs" color="deep-orange">
                  <q-tooltip>
                    لغو شرط
                  </q-tooltip>
                </q-btn>
              </q-card-section>
              <q-card-section class="no-padding" align="center">
                <q-avatar v-if="item.Digikala" size="xs">
                  <img src="../../assets/Sign.svg">
                </q-avatar>
                <q-chip :color="`blue-grey-7`" text-color="white" square
                        clickable
                        @click="$emit('city-selected', [item]);item.selected = true;cancelAllFilter(item)"
                        :label="item.City" icon="location_city">
                  <q-badge :color="`red-10`" text-color="white" floating :label="item.ExiCount"/>
                </q-chip>
                <q-space/>
                <q-chip dense :color="`indigo-10`" text-color="white" square
                        label="تاخیر"
                        icon="event">
                  <q-badge color="red-10" class="q-ml-xs" rounded text-color="white" :label="item.SendDelay"/>
                  <span class="q-ml-xs">روز</span>
                </q-chip>
                <q-space/>
                <q-chip dense :color="`deep-orange-10`" text-color="white" square
                        label="تاریخ اولین سفارش"
                        icon="event">
                  <q-badge color="indigo-10" class="q-ml-xs" rounded text-color="white" :label="item.MinDate"/>
                </q-chip>
                <q-space v-if="item.MinDate!==item.MaxDate"/>
                <q-chip dense :color="`deep-orange-10`" text-color="white" square
                        v-if="item.MinDate!==item.MaxDate"
                        label="تاریخ آخرین سفارش"
                        icon="event">
                  <q-badge color="indigo-10" class="q-ml-xs" rounded text-color="white" :label="item.MaxDate"/>
                </q-chip>
                <q-space/>
                <q-chip dense :color="`green-10`" text-color="white" square
                        label="جمع مبلغ"
                        icon="attach_money">
                  <q-badge color="indigo-10" class="q-ml-xs" rounded text-color="white"
                           :label="item.Sale_Pay.toLocaleString()"/>

                  <q-tooltip content-class="bg-white text-center">
                    <q-chip
                        v-if="$store.state.roles.some(v=>['admin','can_see_by_price','can_see_buy_price_summary_order_trace'].includes(v))"
                        dense
                        color="indigo" text-color="white" square
                        label="اختلاف با خرید روز"
                        icon="attach_money">
                      <q-badge class="q-ml-xs" style="direction: ltr"
                               :color="(item.Sale_Pay-item.Buy_DayPrice)>0?'green':'red-10'"
                               :label="(item.Sale_Pay-item.Buy_DayPrice).toLocaleString()"/>
                    </q-chip>
                    <q-space/>
                    <q-chip dense square :label="`${item.Box} کارتن`"/>
                    <q-space/>
                    <q-chip dense square :label="`${item.Weight} کیلو`"/>
                  </q-tooltip>
                </q-chip>
                <q-space/>
                <q-chip
                    v-if="$store.state.roles.some(v=>['admin','can_see_by_price','can_see_buy_price_summary_order_trace'].includes(v))"
                    dense
                    color="indigo" text-color="white" square
                    label="اختلاف با خرید روز"
                    icon="attach_money">
                  <q-badge class="q-ml-xs" style="direction: ltr"
                           :color="(item.Sale_Pay-item.Buy_DayPrice)>0?'green':'red-10'"
                           :label="(item.Sale_Pay-item.Buy_DayPrice).toLocaleString()"/>
                </q-chip>
              </q-card-section>
            </q-card>
          </q-carousel-slide>
        </q-carousel>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import CurrentVelocity from "@/components/OrderTrace/CurrentVelocity";
import CurrentSaleRate from "@/components/OrderTrace/CurrentSaleRate";
import ConversionRate from "@/components/OrderTrace/ConversionRate";
import CustomerUniq from "@/components/OrderTrace/CustomerUniq.vue";
import CustomerRetention from "@/components/OrderTrace/CustomerRetention.vue";
import NewCustomer from "@/components/OrderTrace/NewCustomer.vue";
import NewCustomerNotActive from "@/components/OrderTrace/NewCustomerNotActive.vue";
import NewCustomerActive from "@/components/OrderTrace/NewCustomerActive.vue";
import AverageSaleRateInMonth from "@/components/OrderTrace/AverageSaleRateInMonth.vue";
import {value} from "lodash/seq";

export default {
  name: "Summary",
  components: {
    AverageSaleRateInMonth,
    NewCustomerActive,
    NewCustomerNotActive,
    NewCustomer, CustomerRetention, CustomerUniq, ConversionRate, CurrentSaleRate, CurrentVelocity
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    velocityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    newCustomerList: {
      type: Array,
      required: false,
      default: () => []
    },
    newCustomerListNotActive: {
      type: Array,
      required: false,
      default: () => []
    },
    totalSale: {
      type: Number,
      default: () => undefined
    }
  },
  data() {
    return {
      selected: false,
      slide: 0,
      slideSummary: "CurrentVelocity",
    }
  },
  methods: {
    value,
    cancelAllFilter(item) {
      this.items.filter(rec => rec.City_ID !== item.City_ID).forEach((record) => {
        record.selected = false
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>